import PropTypes from 'prop-types';

import Box from 'shared_DEPRECATED/components/Box/Box';
import { Flex } from 'shared_DEPRECATED/components/Flex';

import { Dropdown, DropdownItem } from 'shared/components/Dropdown';
import { SidebarMainHeader } from 'shared/components/Sidebar';
import { useSidebarContext } from 'shared/components/Sidebar/context';
import { Typography } from 'shared/components/Typography';

const SprintHistoryHeaderPropTypes = {
  selectedSprintId: PropTypes.string.isRequired,
  setSelectedSprintId: PropTypes.func.isRequired,
};

const SprintHistoryHeader = ({ selectedSprintId, setSelectedSprintId }) => {
  const { sprints } = useSidebarContext();

  if (!sprints) {
    return null;
  }

  return (
    <SidebarMainHeader title="History">
      {sprints.length > 1 ? (
        <Dropdown
          onItemSelect={(selectedSprintId) => {
            setSelectedSprintId(selectedSprintId);
          }}
          anchorContent={
            <Box style={{ maxWidth: '13rem' }}>
              <Typography cropped={true}>
                {
                  sprints.find((sprint) => sprint.sprintId === selectedSprintId)
                    .title
                }
              </Typography>
            </Box>
          }
          selectedValue={selectedSprintId}
          portalled={false}
        >
          <Box style={{ width: '15rem' }} role="listbox">
            <Flex alignItems="stretch" flexDirection="column">
              {sprints.map((sprint) => (
                <DropdownItem key={sprint.sprintId} value={sprint.sprintId}>
                  {sprint.title}
                </DropdownItem>
              ))}
            </Flex>
          </Box>
        </Dropdown>
      ) : null}
    </SidebarMainHeader>
  );
};

SprintHistoryHeader.propTypes = SprintHistoryHeaderPropTypes;

export default SprintHistoryHeader;
